import {ERROR_CONTENT} from './errorsData';
import {FormError} from "app/model/FormError";

export const validateEmail = (email) => {
    const errors = [];

    if (!email) {
        errors.push(FormError.createEmailType(ERROR_CONTENT['not_blank']));
    }

    if (!isValidEmail(email)) {
        errors.push(FormError.createEmailType(ERROR_CONTENT['invalid_email']));
    }

    return errors;
};

export const validatePhone = (phone) => {
    const errors = [];

    if (!phone) {
        errors.push(FormError.createPhoneType(ERROR_CONTENT['not_blank']));
    }

    if (!isValidPhone(phone)) {
        errors.push(FormError.createPhoneType(ERROR_CONTENT['invalid_phone']));
    }

    return errors;
};

export const validateUsername = (username) => {
    const errors = [];

    if (!username) {
        errors.push(FormError.createUsernameError(ERROR_CONTENT['not_blank']));
    }

    if (!isValidEmail(username) && isNaN(username)) {
        errors.push(FormError.createUsernameError(ERROR_CONTENT['invalid_username']));
    }

    return errors;
};

export const validateNullability = (value, type) => {
    const errors = [];

    if (!value) {
        errors.push(new FormError({type, content: ERROR_CONTENT['not_blank']}));
    }

    return errors;
};

const isValidEmail = (email) => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
const isValidPhone = (phone) => /\(?\+?(\d{2,3})?\)?[\s|-]?\d{3}[\s|-]?\d{3}[\s|-]?\d{3}/.test(phone);